import { useMemo } from "react";
import {
  isValidPalette,
  Palette,
  UnvalidatedThemeModel,
} from "../types/ThemeModel";

export function useIsValidPalette(
  palettes: Array<NonNullable<UnvalidatedThemeModel>["palette"]>
): palettes is Array<Palette>;
export function useIsValidPalette(
  palette: NonNullable<UnvalidatedThemeModel>["palette"]
): palette is Palette;
export function useIsValidPalette(
  palette:
    | NonNullable<UnvalidatedThemeModel>["palette"]
    | Array<NonNullable<UnvalidatedThemeModel>["palette"]>
): palette is Palette | Array<Palette>;
export function useIsValidPalette(
  palette:
    | NonNullable<UnvalidatedThemeModel>["palette"]
    | Array<NonNullable<UnvalidatedThemeModel>["palette"]>
): boolean {
  return useMemo(
    () =>
      Array.isArray(palette)
        ? palette.every(isValidPalette)
        : isValidPalette(palette),
    [palette]
  );
}
